module.exports = __webpack_public_path__ + "img/yun-zuo.fb96eedf.png";